import PublicPageLayout from './PublicPageLayout';

export default PublicPageLayout;
